<template>
  <div>
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-5 mb-4">
                <div class="d-flex align-items-center gap-1 items-center">
                  <h4 class="card-title">Participantes não alocados</h4>
                  <span class="badge badge-soft-warning font-size-13 mb-2" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden; font-weight: 500;">{{ totalRows }} PARTICIPANTES</span>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right me-2" v-if="canManageHousing">
                    <button type="button" class="btn btn-info mb-2 mr-2" @click="showFreeAllocation()">
                      <i class="bx bx-grid-alt mr-1"></i> Alocação livre
                    </button>
                  </div>
                  <div class="text-sm-right me-2" v-if="canManageHousing">
                    <button type="button" class="btn btn-info mb-2 mr-2" @click="showAllocationAll()">
                      <i class="bx bx-git-compare mr-1"></i> Alocação em massa
                    </button>
                  </div>
                  <div class="text-sm-right me-2">
                    <button type="button" class="btn btn-light mb-2 mr-2" @click="showFilters()">
                      <i class="mdi mdi-filter mr-1"></i> Filtrar
                    </button>
                  </div>
                  <div class="text-sm-right">
                    <button type="button" class="btn btn-primary mb-2 mr-2" @click="exportParticipants()">
                      <i class="mdi mdi-export mr-1"></i> Exportar
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="search-box mr-2 mb-2">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Buscar por nome" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="20%">Nome</th>
                    <th width="20%">E-mail</th>
                    <th width="15%">Grupo</th>
                    <th width="10%">Sexo</th>
                    <th width="20%">Confirmado em</th>
                    <th width="10%">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in participants" :key="list.id" class="text-muted">
                    <td>
                      <h5 class="font-size-13" style="white-space: nowrap;text-overflow: ellipsis;max-width: 275px;overflow: hidden; text-transform: capitalize;">{{ list.name }}</h5>
                    </td>
                    <td>{{ list.email }}</td>
                    <td style="font-size: 12px !important;">
                      <span class="badge badge-soft-primary font-size-12" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden;">
                        {{ list.group ? list.group.data.name : 'SEM GRUPO' }}
                      </span>
                    </td>
                    <td style="font-size: 12px !important;">{{ list.gender }}</td>
                    <td style="font-size: 12px !important;">{{ list.confirmado }}</td>
                    <td>
                      <button type="button" class="btn btn-primary btn-sm" @click="newAllocation(list)" v-if="canManageHousing">Alocar</button>
                      <span v-else class="text-muted">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-filter v-model="modalFilter" ref="modalFilter" @participantFiltered="getReport"></modal-filter>
    <modal-allocation-all v-model="modalAllocationAll" ref="modalAllocationAll" @allocaded="updateList"></modal-allocation-all>
    <modal-form v-model="modalForm" ref="formAllocation" @created="updateList"></modal-form>
    <free-allocation ref="freeAllocation" @allocated="updateList"></free-allocation>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import { mapActions, mapState, mapGetters } from 'vuex'
import ModalForm from './allocation/Form'
import ModalAllocationAll from './allocation/AllocationAll'
import ModalFilter from './allocation/Filter'
import FreeAllocation from '../free-allocation/FreeAllocation'
import http from '@/http'
import serviceReport from './services'
import { EventBus } from '@/eventBus'
// import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    ModalForm,
    ModalFilter,
    ModalAllocationAll,
    FreeAllocation
  },
  name: 'allocations-room',
  page: {
    title: 'Gestão de Hospedagem',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      timeout: 60000,
      search: '',
      participants: [],
      modalForm: false,
      modalAllocationAll: false,
      modalFilter: false,
      statusLabel: ['Ocupado', 'Disponível'],
      params: {
        hotel_id: null,
        category_id: null
      },
      totalRows: 1,
      currentPage: 1,
      pagination: {
        total: 0,
        current_page: 1
      },
      perPage: 5,
      hotelId: null,
      idParticipant: null,
      allocated: null,
      submitted: false,
      title: 'Gestão de Hospedagem'
    }
  },
  created () {
    EventBus.$on('allocationRemoved', (action) => {
      if (action) {
        this.updateList()
      }
    })
  },
  mounted () {
    this.updateList()
    // this.totalRows = this.pagination.total
    // this.currentPage = this.pagination.current_page
    this.loading = false
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['hasPermission', 'isSuperAdmin']),
    rows () {
      return this.pagination.total
    },
    canManageHousing () {
      return this.isSuperAdmin || this.hasPermission('housing.manage')
    }
  },
  methods: {
    ...mapActions('participant', {
      getAll: 'getNotAllocated'
    }),
    exportParticipants () {
      let loeader = this.$loading.show()
      serviceReport.exportParticipants(this.params).then((res) => {
        this.download(res)
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    getParticipantsNotAllocated () {
      let params = {}
      http.get(`/admin/metrics/participantsNotAllocated`, { params }).then((response) => {
        this.allocated = response.data
      }).catch((error) => {
        console.error(error)
      })
    },
    newAllocation (participant) {
      this.$refs.formAllocation.open(participant)
      this.modalForm = true
    },
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    showFilters () {
      this.$refs.modalFilter.open()
      this.modalFilter = true
    },
    showAllocationAll () {
      this.$refs.modalAllocationAll.open()
      this.modalAllocationAll = true
    },
    showFreeAllocation () {
      this.$refs.freeAllocation.open()
    },
    getReport (filter) {
      let params = {
        include: 'group',
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage,
        gender: filter.gender || null,
        group_id: filter.group_id || null,
        tags: filter.tagsIds || null,
        city: filter.city || null,
        district: filter.district || null,
        created_start: filter.created_start ? this.$moment(filter.created_start).format('YYYY-MM-DD') : null,
        created_end: filter.created_end ? this.$moment(filter.created_end).format('YYYY-MM-DD') : null,
        confirmation_date_start: filter.confirmation_date_start ? this.$moment(filter.confirmation_date_start).format('YYYY-MM-DD') : null,
        confirmation_date_end: filter.confirmation_date_end ? this.$moment(filter.confirmation_date_end).format('YYYY-MM-DD') : null
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        console.log(res)
        this.participants = res.data
        this.totalRows = res.meta.pagination.total
        this.currentPage = res.meta.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { max-height: 520px;}
.float-sm-end { float: right }
</style>
